module.exports = __webpack_public_path__ + "img/login-img.6824eec8.png";